import { render, staticRenderFns } from "./dialog-multidelete-new.vue?vue&type=template&id=bf0d6e32&"
import script from "./dialog-multidelete-new.vue?vue&type=script&lang=js&"
export * from "./dialog-multidelete-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports